/**
*
* useApi3
* TODO: refactor using useRestApi
*/

import { useEffect } from 'react';
import useAuthorizedRequest from 'containers/Api2/useAuthorizedRequest.js';
import { mergeObjects } from './reduceObjects.js';

const defaultReducer = mergeObjects;

function useApi3(options, setState) {
  const { url, skipLoading } = options;
  const { authFetch } = useAuthorizedRequest();

  async function loadData(loadOptions) {
    const allOptions = { ...options, ...loadOptions };
    const { busyProp = 'loading', reducer = defaultReducer, replace } = allOptions;
    if (replace) {
      setState({ [busyProp]: true });
    } else {
      setState((prev) => ({ ...prev, [busyProp]: true }));
    }
    const data = await authFetch(allOptions);
    data[busyProp] = false;
    if (data.error) {
      console.warn('useApi3 error', data.error); // eslint-disable-line no-console
    } else {
      data.ready = true;

      if (data.hasMore) {
        data.loadMore = () => loadData({ url: data.nextUrl });
      }
      if (data.hasNew) {
        data.loadNew = () => loadData({ url: data.nextSince });
      }
    }
    setState((prev) => reducer(prev, data));
  }

  useEffect(() => {
    if (url && !skipLoading) {
      loadData({ url, replace: true });
    }
  }, [url]); // eslint-disable-line react-hooks/exhaustive-deps

  return loadData;
}

export default useApi3;
